const DETAILS_CONSTANTS = {
  // Long dashes - not to mistake with regular dash
  EMPTY_FIELD: '— —',
  DOWNLOAD: 'Download',
  SET_TO_TRUE: 'Yes',
  SET_TO_FALSE: 'No',
};

export { DETAILS_CONSTANTS };
